import { render, staticRenderFns } from "./NewsBW2026FukuokaENG.vue?vue&type=template&id=00fa13a6&scoped=true&"
import script from "./NewsBW2026FukuokaENG.vue?vue&type=script&lang=js&"
export * from "./NewsBW2026FukuokaENG.vue?vue&type=script&lang=js&"
import style0 from "./NewsBW2026FukuokaENG.vue?vue&type=style&index=0&id=00fa13a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa13a6",
  null
  
)

export default component.exports